import React, { createContext, useEffect, useState } from "react";
import ApiService from "./api";
import { User } from "../apps/user/model/user";

const AuthContext = createContext();

export default function AuthProvider({ children }) {
  const [user, setUser] = useState({});
  const [isUserLoading, setIsUserLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState();
  const [isEnglish, setIsEnglish] = useState(
    () => localStorage.getItem("english") === "true"
  );

  const toggleLanguage = () => {
    const newLanguage = !isEnglish;
    setIsEnglish(newLanguage);
    localStorage.setItem("english", newLanguage ? "true" : "false");
  };

  const login = async (loginFormData) => {
    try {
      const userData = await ApiService.login(loginFormData);
      if (userData) {
        setUser(userData);
        setIsAuthenticated(true);
        setIsUserLoading(false);
        return true;
      }
    } catch (error) {
      console.error("Login error", error);
      return false;
    }
    return false;
  };

  const logout = async () => {
    const confirmed = window.confirm("Sei sicuro di voler uscire?");
    if (confirmed) {
      await ApiService.logout();
      window.location.replace("/");
    }
  };

  const fetchUser = async () => {
    setIsUserLoading(true);
    try {
      const data = await ApiService.getUser();
      if (data) {
        setUser(new User(data));
        setIsUserLoading(false);
        setIsAuthenticated(true);
        return data;
      } else {
        setIsUserLoading(false);
        return null;
      }
    } catch {
      setIsUserLoading(false);
      return null;
    }
  };

  useEffect(() => {
    fetchUser();
  }, [isAuthenticated]);

  const auth = {
    isAuthenticated,
    isLoading: isUserLoading,
    isEnglish,
    user,
    login,
    toggleLanguage,
    logout,
  };

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export { AuthContext };
